import { FC, useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import { useDuplicateRecordsV2 } from "@lhd/hooks";
import Button from "@lhd/components/Button";
import { getCompanyId } from "@lhd/utility";
import { AppTypes, IPermissionItem } from "@lhd/types";

export interface ButtonDuplicateProps {
  appType: AppTypes;
  appId: string;
  recordId: string;
  isEditing: boolean;
  onLoadingChange?: (loading: boolean) => void;
  permission?: IPermissionItem;
}

const ButtonDuplicate: FC<ButtonDuplicateProps> = ({
  appType,
  appId,
  recordId,
  isEditing,
  onLoadingChange,
  permission,
}) => {
  const navigate = useNavigate();
  const { companyId: companyIdParam } = useParams();
  const companyId = Number(companyIdParam || getCompanyId());
  const { mutateAsync: duplicateRecordsAsync, isLoading: isDuplicating } =
    useDuplicateRecordsV2({
      appType,
      appId,
      companyId,
    });

  useEffect(() => {
    onLoadingChange?.(isDuplicating);
  }, [isDuplicating, onLoadingChange]);

  const handleDuplicateRecord = useCallback(async () => {
    const id = Number(recordId);
    if (!appId || !Number.isFinite(id)) return;
    try {
      await duplicateRecordsAsync({
        payload: {
          record_ids: [id],
          target_company_ids: [Number(getCompanyId())],
        },
      });
    } catch (e: any) {
      notification["error"]({
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          "複製に失敗しました",
      });
    }
  }, [appId, recordId, duplicateRecordsAsync, navigate]);

  return (
    <Button
      disabled={!isEditing || isDuplicating || !permission?.create}
      loading={isDuplicating}
      label={"行コピー"}
      onClick={handleDuplicateRecord}
    />
  );
};

export default ButtonDuplicate;
